let map = {
    mymap: '',
    style: '',
    themeUrl: wpurls.siteUrl,
    png: '',
    pngFocus: '',
    popUpContent: '',
    locations: (typeof mapJson !== 'undefined' && mapJson.length > 0) ? mapJson : '',
    refreshTrigger: [],

    init: function () {
        if(typeof mapJson !== 'undefined' && mapJson.length > 0) {
            var notMobile = !L.Browser.mobile;
            map.mymap = L.map('leaflet-map', {
                doubleClickZoom: false,
                dragging: notMobile,
                scrollWheelZoom: false
            })
            // map.scrollWheelZoom.disable();

            if(document.querySelectorAll('body.single-programmes').length > 0) {
                map.mymap.scrollWheelZoom.disable();
            }

            setTimeout(function () {
                map.mymap.invalidateSize();
            }, 500);

            const mapStyles = ['Cartographie', 'Satellite'];
            const mapLayers = [];
            const layerParams = {subdomains:['mt0','mt1','mt2','mt3']};

            /**
             layers (lyrs=) parameter
                Hybrid (Satellite with labels): y;
                Cartographie: m;
                Satellite: s;
                Terrain: p;
            **/
            mapLayers[mapStyles[0]] = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',layerParams);
            mapLayers[mapStyles[1]] = L.tileLayer(`https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}`,layerParams);

            // Default layer
            mapLayers['Cartographie'].addTo(map.mymap);

            L.control.layers(mapLayers).addTo(map.mymap);

            map.png = L.icon({
                iconUrl: `${map.themeUrl}/assets/lib/leaflet/marker-unfocus.svg`,
                iconSize: [31,46],
                iconAnchor: [15.5,36]
            });

            map.pngFocus = L.icon({
                iconUrl: `${map.themeUrl}/assets/lib/leaflet/marker-focus.svg`,
                iconSize: [31,46],
                iconAnchor: [15.5,36]
            });

            if (map.locations[0].isSingular) {
                map.png = L.icon({
                    iconUrl: `${map.themeUrl}/assets/lib/leaflet/marker-blue.png`,
                    iconSize: [47,71],
                    iconAnchor: [23.5,71]
                });
            }

            let boundsArr = [];
            map.locations.forEach(location => {
                map.showOnMap(location);
                if (location.adress.latitude.length > 0 && location.adress.longitude.length > 0) {
                    boundsArr.push([location.adress.latitude, location.adress.longitude, location.structurePrimary]);
                }
            });

            // Zoom map with all marker and zoom dynamic - mode 1
            // Zoom map with the first marker on center (= zoom par structure) - mode 2
            let mode = 2;
            if(boundsArr.length > 0) {
                if (map.locations[0].isSingular) {
                    bounds = L.latLngBounds(boundsArr);
                    map.mymap.fitBounds(bounds, {
                        paddingTopLeft : [50, 50],
                        paddingBottomRight:	[50, 50],
                    });
                    map.mymap.setZoom(15);

                } else {
                    var bounds = [];
                    if(mode == 2) {
                        var boundsFilter = boundsArr.filter(item => item[2] == true);
                        if(boundsFilter.length > 0) {
                            boundsArr = boundsFilter;
                        }
                    }

                    if(boundsArr.length > 0) {
                        bounds = L.latLngBounds(boundsArr);
                        map.mymap.fitBounds(bounds, {
                            paddingTopLeft : [100, 100],
                            paddingBottomRight:	[50, 50],
                        });
                    }
                }
            }


            map.refreshTrigger = [
                document.getElementById('full-map'),
                document.getElementById('no-map'),
                document.getElementById('partial-map')
            ];

            if(!map.locations[0].isSingular) {
                [...map.refreshTrigger].forEach(function(el) {
                    el.addEventListener('click', (e) => {
                        setTimeout(() => {
                            map.mymap.invalidateSize();
                          }, "400")
                    })
                })
            }
        }
    },

    showOnMap: function (location) {

        var hasThumb = '';
        if(!location.img) {
            hasThumb = 'no-thumb';
            location.img = '';
        }

        var priceTxt = '';
        if (location.prix_masque == true || location.price == 0) {
            priceTxt = '<strong>Prix sur demande</strong>';
        } else {
            priceTxt = 'À partir de <strong>' + location.price + ' <span>€</span></strong>';
        }

        map.popUpContent = `
            <a href="${location.url}">
                <figure class="site-${location.provenance}">${location.img}</figure>
                <div class="popup-description">
                    <p class="card-title">${location.title}</p>
                    <p class="card-adress"><span class="ico" data-ico="pin"></span>${location.adress.ville} (${location.adress.code_postal.slice(0, 2)})</p>
                    <p class="card-street">${location.adress.rue}</p>
                    <p class="card-price">${priceTxt}</p>
                </div>
            </a>`;
        var newMarker = new L.Marker([location.adress.latitude, location.adress.longitude], {
            icon: map.png
        }).addTo(map.mymap);

        // La popup d'un marqueur s'ouvre seulement au clic et non au hover. Si l'utilisateur cherche à ouvrir la popup d'un programme et que les programmes sont trop rapprochés, finalement il ouvre un autre programme ce qui résulte à une mauvais expérience utilisateur. Rester au comportement au clic.

        if(!map.locations[0].isSingular) {
            newMarker.addEventListener('click', (e) => {
                e.target.setIcon(map.pngFocus);
            });

            let popup = new L.Popup({
                minWidth:300
            });
            popup.setContent(map.popUpContent);
            newMarker.bindPopup(popup);

            newMarker.getPopup().addEventListener('remove', () => {
                newMarker.setIcon(map.png);
            });
        }
    },
};

document.addEventListener('DOMContentLoaded', map.init);